import React from "react";
import { TextBox } from "./styled";

const ThirdTopicText = ({ name }) => {
  return <TextBox>{name}</TextBox>;
};

export default ThirdTopicText;
